import axiosPrivate from "./axiosPrivate"

export const getInstagramAccountDetails = (instagramAccountId) => {
  return axiosPrivate.get(`/${instagramAccountId}`, {
    params: {
      fields: "username"
    }
  })
} 
